import React, { useEffect, useState, useRef, useMemo, useContext } from "react";
import axios from "axios";
import { useParams, Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import {
  CUSTOM_SELECT_DROPDOWN_STYLE,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../common/Constant";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";
import { Box } from "@mui/material";
import { checkUserPermission } from "../../../common/UserPermission";
import { toastError, toastSuccess, toastWarn } from "../../../common/Toast";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import CommonTabular from "../../../components/Datatable/CommonTabular";
import Reportcurrencysymbols from "../../../common/Reportcurrencysymbols";

const DetailedRegisterLogsReport = (props) => {
  const locationid = localStorage.getItem("Location");
  const token = localStorage.getItem("Token");
  const loginUserId = localStorage.getItem("ID") || "";
  let navigate = useNavigate();
  const {
    CurrencySymbol,
    FractionDigits,
    dateFormate,
    ReportViewPermission,
    currencySymbolLocation,
  } = useContext(AppContext);
  const MySwal = withReactContent(Swal);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [totals, setTotals] = useState({
    totalSales: 0,
    totalDifference: 0,
    totalPositiveDifference: 0,
    totalNegativeDifference: 0,
  });
  const [classicView, setClassicView] = useState(true);

  console.log(responseData, "responseDataresponseData");

  const callback = (payload, enddate2) => {
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };
  const apiCall = () => {
    setLoading(true);
    setResponseData([]);
    setTotals({
      totalSales: 0,
      totalDifference: 0,
      totalPositiveDifference: 0,
      totalNegativeDifference: 0,
    });
    axios
      .get(
        `${config.reportsBaseUrl}/reports/detailedregisterlogsreport?startdate=${startdate}&enddate=${enddate}&locationid=${locationid}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          console.log(res.data.ResponseData, "ResponseData");
          if (res.data.ResponseData.length > 0) {
            setResponseData(res.data.ResponseData);
            const totalSales = res.data.ResponseData.reduce(
              (sum, item) => sum + parseFloat(item.TotalSales),
              0
            );
            const totalDifference = res.data.ResponseData.reduce(
              (sum, item) => sum + parseFloat(item.Difference),
              0
            );
            const totalPositiveDifference = res.data.ResponseData.map((item) =>
              parseFloat(item.Difference)
            )
              .filter((diff) => diff > 0)
              .reduce((sum, diff) => sum + diff, 0);
            const totalNegativeDifference = res.data.ResponseData.map((item) =>
              parseFloat(item.Difference)
            )
              .filter((diff) => diff < 0)
              .reduce((sum, diff) => sum + diff, 0);

            setTotals({
              totalSales,
              totalDifference,
              totalPositiveDifference,
              totalNegativeDifference,
            });
          } else {
            setResponseData([]);
            setTotals({
              totalSales: 0,
              totalDifference: 0,
              totalPositiveDifference: 0,
              totalNegativeDifference: 0,
            });
            toastWarn("No data found for the selected date range.");
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        return res;
      });
  }, []);

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value === 1) {
      setStartDate("");
      setEndDate("");
    }
  };
  const callStoreConfigApi = (registerId) => {
    const formArray = [
      { AppConfigkey: "RegisterId", AppConfigvalue: registerId },
    ];
    const jsonobj = {};
    jsonobj.StoreConfig = formArray;

    let jsonstring = JSON.stringify(jsonobj);

    axios
      .post(
        `${config.storeConfigBaseUrl}/storeconfig/upsert`,
        {
          type: "REGISTER",
          storeconfigxml: jsonstring,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then(async (res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          console.log("success");
          // toastSuccess(SUCCESS_MESSAGE);
        } else {
          toastError(ERROR_MESSAGE);
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleRegisterDelete = (registerId) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to delete this register log entry?",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, confirm it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then((result) => {
      if (result.isConfirmed) {
        // Open the #print-receipt modal using querySelector
        console.log("clicked view receipt");
        let deletePayload = {
          registerId: registerId,
          loginUserId: loginUserId,
        };

        axios
          .post(
            `${config.salesconfigBaseUrl}/sales/registerdeletebyid`,
            deletePayload,
            {
              headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "Access-Control-Allow-Origin": "*",
                Authorization: token,
              },
            }
          )
          .then((res) => {
            if (res.data.ResponseCode === "SUCCESS") {
              localStorage.removeItem("registerId", 0);
              callStoreConfigApi(0);
              toastSuccess(SUCCESS_MESSAGE);
              setLoading(false);
              apiCall();
            } else if (res.data.ResponseCode === "ERROR") {
              toastError(ERROR_MESSAGE);
              setLoading(false);
            }
          })
          .catch((error) => {
            setLoading(false);
          });
      } else {
        MySwal.close();
      }
    });
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );
  let dashStyle = {
    // width: "280px",
    background: "#fff",
    marginTop: "10px",
    borderRadius: "6px",
    padding: "20px",
    border: "1px solid #E8EBED",
  };
  const columns = useMemo(() => [
    {
      header: "Delete",
      accessorKey: "Delete",
      Cell: ({ row }) => (
        <Box
          component="span"
          sx={(theme) => ({
            borderRadius: "0.3rem",
            color: "#343f62",
            maxWidth: "18ch",
            fontWeight: "700",
            textDecoration: "underline",
            textUnderlineOffset: "3px",
            p: "0.3rem",
            cursor: "pointer",
          })}
          onClick={() => handleRegisterDelete(row.original.ID)}
        >
          Delete
        </Box>
      ),
    },
    {
      header: "Details",
      accessorKey: "Customer",
      Cell: ({ row }) => (
        <>
          <Box
            component="span"
            sx={(theme) => ({
              borderRadius: "0.3rem",
              color: "#343f62",
              maxWidth: "18ch",
              fontWeight: "700",
              textDecoration: "underline",
              textUnderlineOffset: "3px",
              p: "0.3rem",
              cursor: "pointer",
            })}
            //   onClick={() => navigate(`/manage-Items/${row.original.ID}`)}
            onClick={() =>
              navigate(`/posregister?type=edit&Id=${row.original.ID}`)
            }
          >
            Edit
          </Box>
          <Box
            component="span"
            sx={(theme) => ({
              borderRadius: "0.3rem",
              color: "#343f62",
              maxWidth: "18ch",
              fontWeight: "700",
              textDecoration: "underline",
              textUnderlineOffset: "3px",
              p: "0.3rem",
              cursor: "pointer",
            })}
            onClick={() => navigate(`/register_log_details/${row.original.ID}`)}
          >
            Details
          </Box>
        </>
      ),
    },
    {
      header: "Register",
      accessorKey: "Register",
    },
    {
      header: "Open Employee",
      accessorKey: "OpenEmployee",
    },
    {
      header: "Close Employee",
      accessorKey: "CloseEmployee",
    },
    {
      header: "Shift Start",
      accessorKey: "ShiftStart",
      Cell: ({ row }) =>
        moment(row.original.ShiftStart).format("YYYY-MM-DD") === "Invalid date"
          ? ""
          : moment(row.original.ShiftStart).format(
              `${dateFormate.toUpperCase()} h:mm A`
            ),
    },
    {
      header: "Shift End",
      accessorKey: "ShiftEnd",
      Cell: ({ row }) => {
        const isInvalidDate =
          moment(row.original.ShiftEnd).format("YYYY-MM-DD") === "Invalid date";

        return (
          <span
            className={isInvalidDate ? "text-red-500 font-bold" : "text-black"}
          >
            {isInvalidDate
              ? "Register Still Open"
              : moment(row.original.ShiftEnd).format(
                  `${dateFormate.toUpperCase()} h:mm A`
                )}
          </span>
        );
      },
    },
    {
      header: "Open Amount",
      accessorKey: "TotalOpenAmount",
      Cell: ({ row }) => {
        const openAmount = row?.original?.TotalOpenAmount;
        if (openAmount == "0.00" || openAmount == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(openAmount),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Close Amount",
      accessorKey: "TotalCloseAmount",
      Cell: ({ row }) => {
        const closeAmount = row?.original?.TotalCloseAmount;
        if (closeAmount == "0.00" || closeAmount == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(closeAmount),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "	Sales",
      accessorKey: "TotalSales",
      Cell: ({ row }) => {
        const sales = row?.original?.TotalSales;
        if (sales == "0.00" || sales == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(sales),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Total Additions",
      accessorKey: "TotalAdditions",
      Cell: ({ row }) => {
        const addition = row?.original?.TotalAdditions;
        if (addition == "0.00" || addition == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(addition),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Total Subtractions",
      accessorKey: "TotalSubtractions",
      Cell: ({ row }) => {
        const subtraction = row?.original?.TotalSubtractions;
        if (subtraction == "0.00" || subtraction == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(subtraction),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Difference",
      accessorKey: "Difference",
      Cell: ({ row }) => {
        const totalDiff = row?.original?.Difference;
        if (totalDiff == "0.00" || totalDiff == "") {
          return 0.0;
        } else {
          return (
            <div>
              {CurrencySymbols(
                Number(totalDiff),
                { CurrencySymbol },
                FractionDigits
              )}
            </div>
          );
        }
      },
    },
    {
      header: "Notes",
      accessorKey: "Notes",
    },
  ]);

  const Classiccolumns = [
    {
      title: "Delete",
      field: "Delete",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      defaultVisible: true,
      formatter: (cell) => {
        const data = cell.getRow().getData();
        const span = document.createElement("span");
        span.textContent = "Delete";
        span.style.borderRadius = "0.3rem";
        span.style.color = "#343f62";
        span.style.maxWidth = "18ch";
        span.style.textDecoration = "underline";
        span.style.textUnderlineOffset = "3px";
        span.style.padding = "0.3rem";
        span.style.cursor = "pointer";
        span.style.fontWeight = "700";
        span.addEventListener("click", (e) => {
          e.preventDefault();
          handleRegisterDelete(data.ID);
        });
        return span;
      },
    },
    // {
    //   title: "Details",
    //   field: "Customer",
    //   size: "110",
    //   filterFn: "contains",
    //   headerFilter: "input",
    //   defaultVisible: true,
    //   formatter: (cell) => {
    //     const data = cell.getRow().getData();
    //     const span = document.createElement("span");
    //     span.textContent = "Delete";
    //     span.style.borderRadius = "0.3rem";
    //     span.style.color = "#343f62";
    //     span.style.maxWidth = "18ch";
    //     span.style.textDecoration = "underline";
    //     span.style.textUnderlineOffset = "3px";
    //     span.style.padding = "0.3rem";
    //     span.style.cursor = "pointer";
    //     span.style.fontWeight = "700";
    //     span.addEventListener("click", (e) => {
    //       e.preventDefault();
    //       navigate(`/posregister?type=edit&Id=${data.ID}`)
    //     });
    //     return span;
    //   },
    // },
    {
      title: "Details",
      field: "Customer", // still needed for filtering/sorting
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      defaultVisible: true,

      formatter: (cell) => {
        const data = cell.getRow().getData();

        const container = document.createElement("div");
        container.style.display = "flex";
        container.style.gap = "0.5rem";

        const createActionButton = (label, onClickHandler) => {
          const btn = document.createElement("span");
          btn.textContent = label;
          btn.style.borderRadius = "0.3rem";
          btn.style.color = "#343f62";
          btn.style.maxWidth = "18ch";
          btn.style.textDecoration = "underline";
          btn.style.textUnderlineOffset = "3px";
          btn.style.padding = "0.3rem";
          btn.style.cursor = "pointer";
          btn.style.fontWeight = "700";
          btn.addEventListener("click", (e) => {
            e.preventDefault();
            onClickHandler();
          });
          return btn;
        };

        // "Edit" button
        const editBtn = createActionButton("Edit", () => {
          navigate(`/posregister?type=edit&Id=${data.ID}`);
        });

        // "Details" button
        const detailsBtn = createActionButton("Details", () => {
          navigate(`/register_log_details/${data.ID}`);
        });

        container.appendChild(editBtn);
        container.appendChild(detailsBtn);

        return container;
      },
    },

    {
      title: "Shift Start",
      field: "ShiftStart",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      defaultVisible: true,
      formatter: (cell) => {
        const rawDate = cell.getValue();
        const formattedDate = moment(rawDate).format(
          `${dateFormate.toUpperCase()}`
        );
        return formattedDate === "Invalid date" ? "" : formattedDate;
      },
    },

    {
      title: "Register",
      field: "Register",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Open Employee",
      field: "OpenEmployee",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Close Employee",
      field: "CloseEmployee",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      defaultVisible: true,
    },
    {
      title: "Shift End",
      field: "ShiftEnd",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      defaultVisible: true,
      formatter: (cell) => {
        const rawDate = cell.getValue();
        const formattedDate = moment(rawDate).format(
          `${dateFormate.toUpperCase()}`
        );
        return formattedDate === "Invalid date" ? "" : formattedDate;
      },
    },
    {
      title: "Total Open Amount",
      field: "TotalOpenAmount",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Total Close Amount",
      field: "TotalCloseAmount",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Total Sales",
      field: "TotalSales",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Total Additions",
      field: "TotalAdditions",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Total Subtractions",
      field: "TotalSubtractions",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Difference",
      field: "Difference",
      headerFilter: "input",
      defaultVisible: true,
      bottomCalc: "sum",
      topCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      bottomCalcFormatter: function (cell) {
        const totalValue = cell.getValue();
        if (totalValue == "0.00" || totalValue === "" || totalValue == null) {
          return `${CurrencySymbol}0.0`;
        }

        return Reportcurrencysymbols(
          Number(totalValue),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
      formatter: function (cell) {
        const value = cell.getValue();
        if (value == "0.00" || value === "") {
          return `${CurrencySymbol}0.0`;
        }
        return Reportcurrencysymbols(
          Number(value),
          { CurrencySymbol },
          FractionDigits,
          currencySymbolLocation
        );
      },
    },
    {
      title: "Notes",
      field: "Notes",
      size: "110",
      filterFn: "contains",
      headerFilter: "input",
      defaultVisible: true,
    },
  ];

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">Register Logs</li>
              </ul>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-2">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report Period
              </label>
              <div className="row">
                <div className="col-md-12 z-4">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-4">
                <div className="row">
                  <ReportDate
                    callback={callback}
                    selectReport={selectReport}
                    showhidecomponent={
                      selectReport == 2 ||
                      selectReport == 3 ||
                      selectReport == 4 ||
                      selectReport == 5 ||
                      selectReport == 6 ||
                      selectReport == 7 ||
                      selectReport == 8 ||
                      selectReport == 9 ||
                      selectReport == 10 ||
                      selectReport == 11 ||
                      selectReport == 12 ||
                      selectReport == 13 ||
                      selectReport == 14 ||
                      selectReport == 15 ||
                      selectReport == 16 ||
                      selectReport == 17 ||
                      selectReport == 18 ||
                      selectReport == 19 ||
                      selectReport == 20 ||
                      selectReport == 21 ||
                      selectReport == 22 ||
                      selectReport == 23 ||
                      selectReport == 24 ||
                      selectReport == 25 ||
                      selectReport == 26 ||
                      selectReport == 27 ||
                      selectReport == 28 ||
                      selectReport == 29 ||
                      selectReport == 30 ||
                      selectReport == 31
                        ? true
                        : false
                    }
                  />
                </div>
              </div>
            )}
            <div className="col-sm-1  align-self-sm-end">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                {""}
              </label>
              <button
                class="btn btn-primary mt-3"
                type="submit"
                onClick={() => apiCall()}
              >
                Submit
              </button>
            </div>
          </div>
          {responseData.length > 0 && (
            <>
              <div
                className="row"
                style={{
                  display: "grid",
                  gap: "1rem",
                  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                }}
              >
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totalData.Subtotalsum} */}
                        {CurrencySymbols(
                          Number(totals.totalSales),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Total Sales</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totals.Totalsum} */}
                        {CurrencySymbols(
                          Number(totals.totalNegativeDifference),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Total Shortages</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totals.Taxsum || 0.0} */}
                        {CurrencySymbols(
                          Number(totals.totalPositiveDifference || 0.0),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Total Overages</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="cards">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {/* ${totals.Profitsum} */}
                        {CurrencySymbols(
                          Number(totals.totalDifference),
                          { CurrencySymbol },
                          FractionDigits
                        )}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Total Difference</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card mt-3">
                <div className="card-body">
                  <div className="container">
                    <div className="col-md-12 text-center " id="header">
                      <h6 class="p">SonarPos</h6>
                      <p className="fw-bold p-regular">Register Logs</p>
                      <div className="row mb-2">
                        <p>
                          Date:{" "}
                          {startdate === "" && enddate === ""
                            ? "All Data"
                            : moment(startdate).format(
                                `${dateFormate.toUpperCase()}`
                              ) +
                              " - " +
                              moment(enddate).format(
                                `${dateFormate.toUpperCase()}`
                              )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="table-responsive">
                    <div className="table mt-3"></div>
                    <div>
                      {ReportViewPermission == true ? (
                        <button
                          className="btn btn-secondary"
                          onClick={() => setClassicView(!classicView)}
                        >
                          {" "}
                          {classicView ? "Classic View" : "Morden View"}
                        </button>
                      ) : (
                        <></>
                      )}
                      {classicView ? (
                        <CommonTabular
                          Data={responseData}
                          columns={Classiccolumns}
                          Groupvalue={["Vendor"]}
                          Reportname={"Register Logs"}
                          frozenRowvalue={0}
                          layout={"fitDataFill"}
                          Onrefresh={() => apiCall()}
                        />
                      ) : (
                        <CommonMatrialReactTable
                          MainHeading="Sonar POS"
                          ReportHeading="Register Logs"
                          columns={columns}
                          data={responseData}
                          startdate={startdate}
                          enddate={enddate}
                          columnGrouping={[]}
                          columnsVisibility={{}}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default DetailedRegisterLogsReport;
